import React from 'react';
import {
  Box, LinearProgress, Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { observer } from 'mobx-react';
import { WelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  progressBar: {
    borderRadius: '1.5rem',
    backgroundColor: '#fff9d8',
    height: '2.5rem',
    width: '100%',
    '& >span': {
      backgroundColor: '#fecc01',
    },
  },
  progressText: {
    position: 'absolute',
    height: 'fit-content',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: 'auto',
    textAlign: 'center',
    fontWeight: 600,
    '& >img': {
      width: '1.1rem',
      maxHeight: '1.1rem',
      verticalAlign: 'middle',
      marginInlineEnd: theme.spacing(0.5),
    },
    '& >span': {
      verticalAlign: 'middle',
    },
  },
}));

const Progress: React.FC = observer(() => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <LinearProgress
        value={WelcomeGiftStore.progress}
        variant="determinate"
        className={classes.progressBar}
      />
      <Typography className={classes.progressText}>
        <img src={ThemeStore.theme.points.gems.icon} alt="" />
        <span>{`${WelcomeGiftStore.points}/${WelcomeGiftStore.total}`}</span>
      </Typography>
    </Box>
  );
});

export default Progress;
